import { useEffect } from 'react';

import { sendGTMEvent } from '@next/third-parties/google';
import { useRouter } from 'next/router';
import QueryString from 'qs';

import appConfig from 'app-config';

import useSelectedTab from 'src/hooks/useSelectedTab';
import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { getUTMParams } from 'src/utils/common';
import { pushEvent } from 'src/utils/event-gateway';

export default function useScreenOpen() {
  const router = useRouter();
  const { selectedTab } = useSelectedTab();

  useEffect(() => {
    if (router.isReady) {
      if (appConfig.gtmId) {
        sendGTMEvent(['config', appConfig.gtmId, { page_path: router.pathname }]);
      }

      const debounceScreenOpenEvent = setTimeout(() => {
        pushEvent({
          eventType: EVENT_TYPE.WEB,
          eventName: EVENT_NAME.SCREEN_OPENED,
          eventParams: {
            tab: selectedTab.name,
            path: router.pathname,
            queryParams: QueryString.stringify(router.query),
            // HTTP referrer와 함께 페이지에 진입한 경우 (일반적인 케이스 추적)
            ...(document.referrer && { documentReferrer: document.referrer }),
            // query param에 referrer가 있는 경우 (바이럴 이벤트 등, 특정 케이스 추적)
            ...(router.query.referrer && { referrer: router.query.referrer }),
          },
          options: { utm_params: getUTMParams(router.query) },
        });
      }, 100);
      return () => {
        clearTimeout(debounceScreenOpenEvent); // 이 전의 timer를 clear합니다.
      };
    }
  }, [router.pathname, router.isReady, router.query, selectedTab.name]);
}
